module.exports = __webpack_public_path__ + "static/media/parts_13.6ca4b142.svg";